import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=c4cc5536&scoped=true&"
import script from "./OffersList.vue?vue&type=script&lang=ts&"
export * from "./OffersList.vue?vue&type=script&lang=ts&"
import style0 from "./OffersList.vue?vue&type=style&index=0&id=c4cc5536&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cc5536",
  null
  
)

export default component.exports